<div class="questionContainer">
  <div class="text ms-0" [ngClass]="{'text-three' : nooflines == 3}">{{header}}</div>
  <button class="answer" [ngClass]="{'answer-required' : questionValue == null, 'answer-on' : questionValue === false, 'three' : nooflines == 3 }"
          [disabled]="disabled" tabindex="0" (click)="answerNo()">No
  </button>
  <button class="answer" [ngClass]="{'answer-required' : questionValue == null, 'answer-on' : questionValue === true, 'three' : nooflines == 3 }"
          [disabled]="disabled" tabindex="0" (click)="answerYes()">Yes
  </button>
</div>
